var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"faqs-button-slider"},[_c('faqs-slider',{attrs:{"categories":_vm.categories},on:{"action":_vm.selected}})],1),_vm._v(" "),_c('div',{staticClass:"faqs-grid"},[_c('transition',{attrs:{"name":"fade","tag":"span"}},[_c('category-text',{attrs:{"list":_vm.list,"faqs":_vm.faqs,"categories":_vm.categories}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }